import { useState } from "react";
import axios from "axios";
import { CgClose } from "react-icons/cg";
import { motion, AnimatePresence } from "framer-motion"; // Ajoutez ces imports
import { api } from "../../../../../../../../../api";
import ButtonBlack from "../../../../../../../../components/Buttons/ButtonBlack";

const ConfirmSelectionModal = ({ show=false , applicationId, onClose, onUpdate, showStatusModal }) => {
  const [message, setMessage] = useState("Félicitations ! Vous avez été sélectionné pour cette opportunité.");
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    // try {
      await axios.post(`${api}/applications/${applicationId}/select`, {
        status: "Sélectionné",
        message,
      })
      .then((response)=>{
        console.log(response.data)
        // onUpdate(); // Rafraîchir les données après mise à jour
        onClose(); // Fermer le modal
      }).catch ((error)=> {
      console.error("Erreur lors de la mise à jour ou de l'envoi de l'email :", error);
    }).finally (()=>{
      setLoading(false);
    })

    //   onUpdate(); // Rafraîchir les données après mise à jour
    //   onClose(); // Fermer le modal
    // } catch (error) {
    //   console.error("Erreur lors de la mise à jour :", error);
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="modal"
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
          initial={{ opacity: 0 }} // Initial state (transparent)
          animate={{ opacity: 1 }} // Final state (fully visible)
          exit={{ opacity: 0 }} // State when the modal is exiting
          transition={{ duration: 0.3 }} // Transition duration
        >
          <motion.div className="bg-white rounded-lg shadow-lg w-96">
            {/* Header */}
            <div className="flex justify-between py-4 border-b px-6">
              <h4 className="text-lg font-bold">Confirmer la sélection</h4>
              <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                <CgClose size={20} />
              </button>
            </div>

            {/* Body */}
            <div className="px-6 space-y-4 py-4">
              <p>Êtes-vous sûr de vouloir sélectionner ce candidat ?</p>

              <p className="font-semibold">Message :</p>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="w-full h-24 border rounded-md p-2 bg-gray-50 focus:outline-none"
              ></textarea>

              {/* Boutons */}
              <div className="flex justify-end space-x-4">
                <button
                  onClick={onClose}
                  className="text-primary-black bg-gray-100 rounded-md px-4 py-2 shadow-sm hover:bg-gray-200"
                >
                  Annuler
                </button>
                <ButtonBlack
                  onClick={handleConfirm}
                  className="text-white bg-green-500 rounded-md px-4 py-2 shadow-sm hover:opacity-80"
                  isLoading={loading}
                >
                  {loading ? "En cours..." : "Confirmer"}
                </ButtonBlack>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ConfirmSelectionModal;
